let youtubePlayers = []
let isYouTubeAPIReady = false

window.onYouTubeIframeAPIReady = function () {
    isYouTubeAPIReady = true
    initYouTubePlayers()
}

function loadYouTubeAPI() {
    if (!window.YT && !document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        const tag = document.createElement('script')
        tag.src = 'https://www.youtube.com/iframe_api'
        document.head.appendChild(tag)
    }
}

function initYouTubePlayers() {
    youtubePlayers.forEach(player => {
        try {
            player.destroy()
        } catch (e) {
        }
    })
    youtubePlayers = []

    if (!window.YT || !isYouTubeAPIReady) {
        loadYouTubeAPI()
        return
    }

    const youtubeElements = document.querySelectorAll('[data-youtube-id]')
    youtubeElements.forEach(element => {
        const youtubeId = element.getAttribute('data-youtube-id')
        if (youtubeId && element.id) {
            try {
                const player = new YT.Player(element.id, {
                    videoId: youtubeId,
                    width: '100%',
                    height: '100%',
                    playerVars: {
                        autoplay: 0,
                        controls: 1,
                        modestbranding: 1,
                        rel: 0
                    }
                })
                youtubePlayers.push(player)
            } catch (error) {
                console.error('YouTube player error:', error)
            }
        }
    })
}

export function initVideoPlayers() {
    initYouTubePlayers()
}

export function destroyVideoPlayers() {
    youtubePlayers.forEach(player => {
        try {
            player.destroy()
        } catch (e) {
        }
    })
    youtubePlayers = []
}
